import { useEffect, useState } from 'react';
import { FcPortraitMode } from 'react-icons/fc';
import { RiDeleteBinLine } from 'react-icons/ri';
import { deleteUser, getJUsersList } from '../../api/common';
import { JDData } from '../../commonTypes';
import ConfirmBox from '../../Components/ConfirmBox';
import TableContainer from '../../Components/Table';
import { ERROR_MESSAGE, SUCCESS_MESSAGE } from '../../constants';
import CreateUserModal from '../../Containers/CreateUsers';
import { encrypt } from '../../utils';
import PageContainer from '../PageContainer';
import styles from './style.module.scss';
import Alert from '../../Components/AlertPopup';

const ManageUsers = () => {
  const [userList, setUserList] = useState<JDData[]>([]);
  const [showModal, setShowModal] = useState<boolean>(false);
  const [deleteId, setDeleteId] = useState<string>('');
  const [showToast, setShowToast] = useState(false);
  const [showErrorToast, setShowErrorToast] = useState(false);
  const [showConfirm, setShowConfirm] = useState<boolean>(false);
  const [pageSize, setPageSize] = useState<number>(10); // Default page size
  const [currentPage, setCurrentPage] = useState<number>(1);

  const deleteJD = () => {
    const requestDelete = async () => {
      await deleteUser(encrypt(deleteId))
        .then((response) => {
          setShowConfirm(false);
          setShowToast(true);
          fetchUsersList();
        })
        .catch((err) => {
          setShowErrorToast(true);
        });
    };
    requestDelete();
  };

  const showConfirmBox = (id: string) => {
    setDeleteId(id);
    setShowConfirm(true);
  };

  useEffect(() => {
    fetchUsersList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const columnData = [
    { label: 'No', key: 'no' },
    { label: 'Name', key: 'name' },
    { label: 'Username', key: 'username' },
    { label: 'Role', key: 'roleType' },
    { label: 'Email', key: 'email' },
    { label: 'Supervisor Email', key: 'supervisorEmail' },

    { label: 'Action', key: 'action' }
  ];

  const fetchUsersList = async () => {
    const finalSet: any = [];
    const response = await getJUsersList();

    let i = 1;
    if (response && response.length > 0) {
      response.forEach((element) => {
        finalSet.push({
          no: i,
          action: (
            <>
              <RiDeleteBinLine
                className="hoverHand"
                onClick={() => showConfirmBox(element.userId)}
              />
            </>
          ),

          ...element
        });
        i++;
      });
    }
    setUserList(finalSet);
  };

  const onclickAddVendor = () => {
    setShowModal(true);
  };
  const closeModal = () => {
    setShowModal(false);
    fetchUsersList();
  };

  const handleClose = () => setShowConfirm(false);
  const handleToastClose = () => setShowToast(false);
  const handleErrorClose = () => setShowErrorToast(false);
  const handlePageChange = (pageNumber: number) => {
    setCurrentPage(pageNumber);
  };

  const handlePageSizeChange = (newLimit: number) => {
    setPageSize(newLimit);
    setCurrentPage(1); // Reset to first page on limit change
  };
  return (
    <PageContainer>
      <div className={styles.title}>
        {' '}
        <FcPortraitMode size={30} /> &nbsp; Users
      </div>
      <br />

      <TableContainer
        columnData={columnData}
        rowData={userList}
        title={'List of Users'}
        enableActionButton={true}
        enableFilter={true}
        itemsPerPage={pageSize}
        buttonValue={'+ Add'}
        buttonOnClick={onclickAddVendor}
        totalResult={userList.length}
        currentPage={currentPage}
        onPageNoChange={handlePageChange}
        onPageLimitChange={handlePageSizeChange}
      />
      <ConfirmBox
        message="Are you sure you want to delete the user?"
        handleClose={handleClose}
        show={showConfirm}
        onConfirm={deleteJD}
      />
      <Alert
        show={showToast}
        onClose={handleToastClose}
        message={SUCCESS_MESSAGE.USER_DELET_SUCCESS_MESSAGE}
      />
      <Alert
        type='error'
        show={showErrorToast}
        onClose={handleErrorClose}
        message={ERROR_MESSAGE.API_ERROR_MESSAGE}
      />

      <CreateUserModal showModal={showModal} onClose={closeModal} />
    </PageContainer>
  );
};

export default ManageUsers;
